// src/pages/station_types/StationTypeForm.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import stationTypeService from '../../services/stationTypeService';
import eventSectionService from '../../services/eventSectionService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import { isEmpty, map } from 'lodash';
import eventService from '../../services/eventService';

const StationTypeForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [eventSections, setEventSections] = useState([]);
  const [events, setEvents] = useState([]);
  const [initialValues, setInitialValues] = useState({
    type: '',
    event_id: '',
    event_section_id: '',
  });

  useEffect(() => {
    const fetchStationType = async () => {
      if (id) {
        const response = await stationTypeService.getStationType(id);
        setInitialValues(response.data);
      }
    };
    fetchStationType();
  }, [id]);

  const eventSectionList = async () => {
    const response = await eventSectionService.getEventSections();
    setEventSections(response.data);
  };

  const fetchEvents = async () => {
    const response = await eventService.getEvents();
    setEvents(response.data);
  };

  useEffect(() => {
    eventSectionList();
    fetchEvents();
  }, []);

  const validationSchema = Yup.object().shape({
    type: Yup.string().required('Type is required'),
    event_id: Yup.string().required('Event ID is required'),
    event_section_id: Yup.string().required('Event Section ID is required'),
  });

  const handleSubmit = async (values) => {
    if (id) {
      await stationTypeService.updateStationType(id, values);
    } else {
      await stationTypeService.createStationType(values);
    }
    navigate('/station-types');
  };

  const labelStyle = {
    color: '#000',
    fontSize: '0.87rem',
    marginTop: 8,
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'Edit Station Type' : 'Add Station Type'}
        backTo='/station-types'
      />
      <div className='page-content-wrapper scrollable'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ handleChange, handleBlur, values, errors, touched }) => (
            <Form>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Type</div>
                <Field
                  as={TextField}
                  name='type'
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.type && errors.type && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.type}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Event</div>
                <Select
                  name='event_id'
                  value={values.event_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(events) ? (
                    map(events, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.event_id && errors.event_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.event_id}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
                <div style={labelStyle}>Event Section</div>
                <Select
                  name='event_section_id'
                  value={values.event_section_id}
                  fullWidth
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  {!isEmpty(eventSections) ? (
                    map(eventSections, (option) => (
                      <MenuItem key={option?.id} value={option?.id}>
                        {option?.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem>No data found</MenuItem>
                  )}
                </Select>
                {touched.event_section_id && errors.event_section_id && (
                  <FormHelperText style={{ color: '#D32F2F' }}>
                    {errors.event_section_id}
                  </FormHelperText>
                )}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  type='submit'
                  variant='contained'
                  sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                >
                  {id ? 'Update' : 'Create'}
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </LayoutContainer>
  );
};

export default StationTypeForm;
